import { Transition } from '@headlessui/react'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from "yup";
import React, { useEffect, useState } from 'react'

export default function DataAccessOffCanvas({ data, openDataAccessOffCan, setOpenDataAccessOffCan, allRoles, allAccessLevel }) {

    const [initialValues, setInitialValues] = useState({
        datasetName: "",
        description: "",
        accessRole: [],
        accessLevel: ''
    });

    const validationSchema = Yup.object({
        datasetName: Yup.string().required("Add dataset name"),
        description: Yup.string().required("Add description"),
        accessRole: Yup.array()
            .min(1, "Select at least one role") // require at least one selection
            .required("Select roles"),
    });

    useEffect(() => {
        setInitialValues({
            datasetName: data?.dataset_name || "",
            description: data?.description || "",
            accessRole: data?.roles?.map(item => item.role_id) || [],
            accessLevel: data?.entity_type_id || ''
        })
    }, [data])
    
    const handleSubmit = async (values, resetForm) => {
        try {

        } catch (e) {
        }
    };

    return (
        <Transition show={openDataAccessOffCan}>
            <div className="fixed inset-0 z-50 flex justify-end">
                {/* Overlay */}
                <div
                    className="fixed inset-0 bg-black bg-opacity-50"
                    onClick={() => setOpenDataAccessOffCan(false)}
                ></div>

                {/* Offcanvas Panel */}
                <div className="relative bg-white w-full max-w-[650px] h-full shadow-lg p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center  pb-3">
                        <h2 className="text-[22px] font-bold text-primary-900">
                            Edit Dataset
                        </h2>
                        <button
                            className="text-gray-500 hover:text-gray-800"
                            onClick={() => setOpenDataAccessOffCan(false)}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Body */}
                    <div className='mt-3'>
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue }) => (
                                <Form >
                                    <label className="text-md text-[#717576] font-normal">
                                        Dataset Name
                                    </label>
                                    <Field
                                        name="datasetName"
                                        type="text"
                                        placeholder="Enter dataset name"
                                        className="w-full border p-3 my-[9px] h-[60px] rounded-[10px]"
                                    />
                                    <ErrorMessage
                                        name="datasetName"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Description
                                        </label>
                                        <Field
                                            name="description"
                                            type="text"
                                            placeholder="Enter description"
                                            className="w-full border p-3 my-[9px] h-[60px] rounded-[10px]"
                                        />
                                        <ErrorMessage
                                            name="description"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Access Roles
                                        </label>
                                        <div className='flex gap-5 mt-2'>
                                            {(allRoles && allRoles.length > 0) &&
                                                allRoles.map((item, index) => {
                                                    return (
                                                        <label className='flex items-center py-2 gap-2 text-gray-500 cursor-pointer' key={index}>
                                                            <Field type="checkbox" name="accessRole" value={item?.role_id} className='mr-2 w-4 h-4' />
                                                            {item?.role_name}
                                                        </label>
                                                    )
                                                })
                                            }
                                        </div>
                                        <ErrorMessage
                                            name="accessRole"
                                            component="div"
                                            className="text-red-500 text-sm"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Access Level
                                        </label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="accessLevel"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="View & Export">View & Export</option>
                                                <option value="No Access">No Access</option>
                                                {(allAccessLevel && allAccessLevel.length > 0) &&
                                                    allAccessLevel.map((item, index) => {
                                                        return (
                                                            <option value={item?.entity_type_id} key={index}>{item?.type_name}</option>
                                                        )
                                                    })
                                                }
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="flex justify-between gap-3 pt-4">
                                        <button
                                            type="button"
                                            onClick={() => setOpenDataAccessOffCan(false)}
                                            className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition btn-primary"
                                        >
                                            Save & Update
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </Transition>
    )
}
